export default function isMobile() {
    //判断当前是PC端还是移动端
    return (/Android|webOS|iPhone|iPod|BlackBerry|SymbianOS/i.test(navigator.userAgent))
}